import * as React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

interface ContainerProps {
  $width?: number
  $alignWithButton?: boolean
}

const Container = styled.div<ContainerProps>`
  position: absolute;
  top: calc(100% + 1px);
  left: ${props => props.$alignWithButton ? 0 : rem(-24)};
  background: ${props => props.theme.palette.neutral.surface.normalBackground};
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1),
              0px 4px 14px 0px rgba(0, 0, 0, 0.05),
              0px 8px 24px 0px rgba(0, 0, 0, 0.05),
              0px 24px 35px 0px rgba(0, 0, 0, 0.05);
  clip-path: inset(0px -50px -50px -50px);
  display: flex;
  width: ${props => props.$width ? rem(props.$width) : 'max-content'};
  max-height: ${rem(651)};
  overflow-y: auto;
  z-index: 1000;
`

interface Props extends React.PropsWithChildren {
  width?: number
  alignWithButton?: boolean
}

function MerchandiseMegaMenuContainer(props: Props) {
  const { width, alignWithButton, children } = props

  return <Container $width={width} $alignWithButton={alignWithButton}>
    {children}
  </Container>
}

export default MerchandiseMegaMenuContainer
